/**
 * The inline text-link style used on the full-page screens that sit outside the
 * app shell (concierge landing, reset password, activation, onboarding), so the
 * links under their cards read the same everywhere.
 */
export const STANDALONE_LINK_CLASS =
  "text-ui-fg-interactive hover:text-ui-fg-interactive-hover font-medium";
